const URL_PARAMETERS = {
	accessCode: 'access_code',
	country: 'country',
	countryId: 'countryid', // soon to be deprecated (replaced by country)
	currency: 'currency',
	email: 'email',
	externalOfferingId: 'eoid',
	language: 'language',
	locale: 'locale', // soon to be deprecated (replaced by language)
	sizeSelect: 'sizeselect',
	userToken: 'user_token',
	voucherCode: 'vc',
};

export default URL_PARAMETERS;
